
/*
	The WeCare page is similar to the privacy policy. 
	We explain why privacy is so important to the user 
	and how we protect him
*/
import { Button } from "@identitybuilding/idb-react-ui-elements";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton, EmailShareButton } from "react-share";
import { HashLink as Link } from "react-router-hash-link";
import { useSelector } from "react-redux";
import Icon from "@identitybuilding/idb-react-iconlib";
import React, { useEffect, useState, Suspense } from "react";


const WeCare = () => {

	const [hideBlock, setHideBlock] = useState(0);

	const translate = useSelector(state => state.general.translate);

	useEffect(() => {
		window.addEventListener("scroll", backgroundBlur);
		return () => window.removeEventListener("scroll", backgroundBlur);
	})

	const backgroundBlur = () => {
		const x = document.body.scrollTop - document.documentElement.clientHeight,
			y = document.documentElement.clientHeight,
			z = ((x / y) * 10) * 3,
			v = (x / y) / 4,
			bg = document.getElementById("privacyBg"),
			ol = document.getElementById("privacyBgOverlay");
		if (x >= 0) {
			if (z < 20) bg.style.filter = `blur(${z}px)`;
			else if (z >= 20) bg.style.filter = "blur(20px)";
			if (v < 0.25) ol.style.backgroundColor = `rgba(0, 0, 0, ${v})`;
			else if (v >= 0.25) ol.style.backgroundColor = "rgba(0, 0, 0, 0.25)";
		} else {
			bg.style.filter = "blur(0)";
			ol.style.backgroundColor = "rgba(0, 0, 0, 0)";
		}
	}


	// Show or hide the extra privacy content
	const hiddenBlockHandler = e => setHideBlock(hideBlock === e ? 0 : e);

	const hiddenStyle = { maxHeight: 0, opacity: 0, transform: "scaleY(0)" },
		shareUrl = translate("url"),
		title = translate("title"),
		visibleStyle = { maxHeight: "4000px", opacity: 1, transform: "scaleY(1)" };

	return (
		<Suspense fallback={<div></div>}>
			<div id="privacy">
				<div className="pBg" id="privacyBg" />
				<div className="pBgOverlay" id="privacyBgOverlay" />
				<div className="shareBtn">
					<div className="shareIcon"><Icon name="Share" /></div>
					<FacebookShareButton url={shareUrl} quote={title}><Icon name="Facebook" /></FacebookShareButton>
					<LinkedinShareButton url={shareUrl} quote={title}><Icon name="Linkedin" /></LinkedinShareButton>
					<TwitterShareButton url={shareUrl} quote={title}><Icon name="Twitter" /></TwitterShareButton>
					<WhatsappShareButton url={shareUrl} quote={title}><Icon name="Whatsapp" /></WhatsappShareButton>
					<EmailShareButton url={shareUrl} quote={title}><Icon name="Mail" />Email</EmailShareButton>
				</div>
				<div className="homeBtn"><Link title='Home' to="#top"><Icon name="Home" /></Link></div>

				{/***** FIRST VIEW *****/}
				<div className="pView">
					<div className="pMessage">
						<h2>{translate("congrats")}</h2>
						<h3>{translate("message")}</h3>
					</div>
				</div>

				{/***** SECOND VIEW *****/}
				<div className="pRow first">
					<div className="pRowImage"><img className='lazyload' data-src={require("../../library/imgs/privacy_search-find-privacy-friendly.webp")} alt={translate("search_find_privacy")} width={250} height={150} /></div>
					<div className="pRowContent">
						<div className="pBlockHeader">
							<h2>{translate("privacyFriendly_title")}</h2>
							<p>{translate("privacyFriendly_content")}</p>
						</div>
						<div className="pBlockContent" style={hideBlock === 1 ? visibleStyle : hiddenStyle}>
							<div className="pBlockPart">
								<h3>{translate("privacyFriendly_title_2")}</h3>
								{translate("privacyFriendly_content_2")}
							</div>
							<div className="pBlockPart">
								<h3>{translate("privacyFriendly_title_3")}</h3>
								{translate("privacyFriendly_content_3")}
							</div>
							<div className="pBlockPart">
								<h3>{translate("privacyFriendly_title_4")}</h3>
								<p>{translate("privacyFriendly_content_4")}</p>
							</div>
						</div>
						<span onClick={() => hiddenBlockHandler(1)}>
							<Button
								borderColor="sub"
								label={translate(hideBlock === 1 ? "close-button" : "privacyFriendly_button")}
								text={translate(hideBlock === 1 ? "button" : "privacyFriendly_button")}
								txtColor="sub"
								type="sub"
							/>
						</span>
					</div>
				</div>

				{/***** THIRD VIEW *****/}
				<div className="pRow pEven">
					<div className="pRowImage"><img className='lazyload' data-src={require("../../library/imgs/privacy_no-more-targeted-ads.svg")} alt={translate("no_targeted_ads")} width={250} height={150} /></div>
					<div className="pRowContent">
						<div className="pBlockHeader">
							<h2>{translate("noWorries_title")}</h2>
							<p>{translate("noWorries_content")}</p>
						</div>
						<div className="pBlockContent" style={hideBlock === 2 ? visibleStyle : hiddenStyle}>
							<div className="pBlockPart">
								<h3>{translate("noWorries_title_1")}</h3>
								<p>{translate("noWorries_content_1")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("noWorries_title_2")}</h3>
								{translate("noWorries_content_2")}
							</div>
							<div className="pBlockPart">
								<h3>{translate("noWorries_title_3")}</h3>
								<p>{translate("noWorries_content_3")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("noWorries_title_4")}</h3>
								<p>
									{translate("noWorries_content_4_part_1")}
									<Link to="/privacy/policy" >
										{translate("noWorries_content_4_part_2")}
									</Link>
									{translate("noWorries_content_4_part_3")
									}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("noWorries_title_5")}</h3>
								<p>{translate("noWorries_content_5")}</p>
							</div>
						</div>
						<span onClick={() => hiddenBlockHandler(2)}>
							<Button
								borderColor="sub"
								label={translate(hideBlock === 2 ? "close-button" : "noWorries_button")}
								text={translate(hideBlock === 2 ? "button" : "noWorries_button")}
								txtColor="sub"
								type="sub"
							/>
						</span>
					</div>
				</div>

				{/***** FOURTH VIEW *****/}
				<div className="pRow noBorder">
					<div className="pRowImage"><img className='lazyload' data-src={require("../../library/imgs/privacy_get-all-results-you-want.svg")} alt={translate("get_results_you_want")} width={250} height={150} /></div>
					<div className="pRowContent">
						<div className="pBlockHeader">
							<h2>{translate("getResults_title")}</h2>
							<p>{translate("getResults_content")}</p>
						</div>
						<div className="pBlockContent" style={hideBlock === 3 ? visibleStyle : hiddenStyle}>
							<div className="pBlockPart">
								<h3>{translate("getResults_title_1")}</h3>
								<p>{translate("getResults_content_1")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("getResults_title_2")}</h3>
								<p>{translate("getResults_content_2")}</p>
							</div>
						</div>
						<span onClick={() => hiddenBlockHandler(3)}>
							<Button
								borderColor="sub"
								label={translate(hideBlock === 3 ? "close-button" : "getResults_button")}
								text={translate(hideBlock === 3 ? "button" : "getResults_button")}
								txtColor="sub"
								type="sub"
							/>
						</span>
					</div>
				</div>

				{/***** FIFTH VIEW *****/}
				<div className="pGDPR">
					<h2>{translate("gdpr_title")}</h2>
					<h3>{translate("gdpr_title_1")}</h3>
					<a href={translate("gdpr_button_link")} target="_blank" rel="noopener noreferrer">
						<Button
							negative
							label={translate("gdpr_button_text")}
							text={translate("gdpr_button_text")}
							type="sub"
						/>
					</a>
				</div>

				{/***** SIXTH VIEW *****/}
				<div className="pRow pEven">
					<div className="pRowImage"><img className='lazyload' data-src={require("../../library/imgs/privacy_more-privacy.svg")} alt={translate("more_privacy")} width={250} height={150} /></div>
					<div className="pRowContent">
						<div className="pBlockHeader">
							<h2>{translate("morePrivacy_title")}</h2>
							<p>{translate("morePrivacy_content")}</p>
						</div>
						<div className="pBlockContent" style={hideBlock === 4 ? visibleStyle : hiddenStyle}>
							<div className="pBlockPart">
								<h3>{translate("morePrivacy_title_1")}</h3>
								{translate("morePrivacy_content_1")}
							</div>
							<div className="pBlockPart">
								<h3>{translate("morePrivacy_title_2")}</h3>
								{translate("morePrivacy_content_2")}
							</div>
							<div className="pBlockPart">
								<h3>{translate("morePrivacy_title_3")}</h3>
								<p>{translate("morePrivacy_content_3")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("morePrivacy_title_4")}</h3>
								<p>{translate("morePrivacy_content_4")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("morePrivacy_title_5")}</h3>
								{translate("morePrivacy_content_5")}
							</div>
							<div className="pBlockPart">
								<h3>{translate("morePrivacy_title_6")}</h3>
								<p>{translate("morePrivacy_content_6")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("morePrivacy_title_7")}</h3>
								<p>{translate("morePrivacy_content_7")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("morePrivacy_title_8")}</h3>
								<p>{translate("morePrivacy_content_8")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("morePrivacy_title_9")}</h3>
								<p>{translate("morePrivacy_content_9")}</p>
							</div>
						</div>
						<span onClick={() => hiddenBlockHandler(4)}>
							<Button
								borderColor="sub"
								label={translate(hideBlock === 4 ? "close-button" : "morePrivacy_button")}
								text={translate(hideBlock === 4 ? "button" : "morePrivacy_button")}
								txtColor="sub"
								type="sub"
							/>
						</span>
					</div>
				</div>

				{/***** SEVENTH VIEW *****/}
				<div className="pRow noBorder">
					<div className="pRowImage"><img className='lazyload' data-src={require("../../library/imgs/privacy_trust-entrepreneurs-network.svg")} alt={translate("privacy_trust_esn")} width={250} height={150} /></div>
					<div className="pRowContent">
						<div className="pBlockHeader">
							<h2>{translate("privacyTrust_title")}</h2>
							<p>{translate("privacyTrust_content")}</p>
						</div>
						<div className="pBlockContent" style={hideBlock === 5 ? visibleStyle : hiddenStyle}>
							<div className="pBlockPart">
								<p>{translate("privacyTrust_content_0")}</p>
								<h3>{translate("privacyTrust_title_1")}</h3>
								<p>{translate("privacyTrust_content_1")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("privacyTrust_title_2")}</h3>
								<p>{translate("privacyTrust_content_2")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("privacyTrust_title_3")}</h3>
								<p>{translate("privacyTrust_content_3")}</p>
							</div>
							<div className="pBlockPart">
								<h3>{translate("privacyTrust_title_4")}</h3>
								<p>{translate("privacyTrust_content_4")}</p>
							</div>
						</div>
						<span onClick={() => hiddenBlockHandler(5)}>
							<Button
								borderColor="sub"
								label={translate(hideBlock === 5 ? "close-button" : "privacyTrust_button")}
								text={translate(hideBlock === 5 ? "button" : "privacyTrust_button")}
								txtColor="sub"
								type="sub"
							/>
						</span>
					</div>
				</div>

				{/***** EIGHTH VIEW *****/}
				{/* <div className="pBookmarking">
				<div className="pRow">
					<div className="pBlockPart">
						<img src={require("../../library/imgs/privacy_add-as-homepage.svg")} alt={translate("add_as_homepage")} />
						<h2>{translate("bookmark_title")}</h2>
						<Button
							borderColor="sub"
							label={translate("bookmark_button")}
							text={translate("bookmark_button")}
							txtColor="sub"
							type="sub"
						/>
					</div>
					<div className="pBlockPart">
						<img src={require("../../library/imgs/privacy_bookmark-us.svg")} alt={translate("bookmark_us")} />
						<h2>{translate("bookmark_title_1")}</h2>
						<Button
							borderColor="sub"
							label={translate("bookmark_button_1")}
							text={translate("bookmark_button_1")}
							txtColor="sub"
							type="sub"
						/>
					</div>
					<div className="pBlockPart">
						<img src={require("../../library/imgs/privacy_mobile friendly.svg")} alt={translate("mobile_friendly")} />
						<h2>{translate("bookmark_title_1")}</h2>
					</div>
				</div>
			</div> */}
			</div>
		</Suspense>
	);
}

export default WeCare
